import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/icons/search.svg'


const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-widget" }
const _hoisted_3 = { class: "category-list list-style" }
const _hoisted_4 = { class: "sidebar-widget" }
const _hoisted_5 = { class: "center" }
const _hoisted_6 = { class: "multi-range" }
const _hoisted_7 = ["min", "max"]
const _hoisted_8 = ["min", "max"]
const _hoisted_9 = { class: "price-title d-flex flex-wrap justify-content-between" }
const _hoisted_10 = {
  id: "from",
  class: "fs-14 text-optional"
}
const _hoisted_11 = {
  id: "to",
  class: "fs-14 text-optional"
}
const _hoisted_12 = { class: "sidebar-widget" }
const _hoisted_13 = { class: "tag-list list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"sidebar-widget\" data-v-0f8e4fb1><h3 class=\"sidebar-widget-title\" data-v-0f8e4fb1>Search Product</h3><form action=\"#\" class=\"search-area position-relative w-sm-100\" data-v-0f8e4fb1><input type=\"search\" placeholder=\"Search Product\" class=\"w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black\" data-v-0f8e4fb1><button type=\"submit\" class=\"bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-3\" data-v-0f8e4fb1><img src=\"" + _imports_0 + "\" alt=\"Image\" data-v-0f8e4fb1></button></form></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "sidebar-widget-title" }, "Categories", -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Electronics "),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [2]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Mockup"),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Laptop"),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [4]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Camera"),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [5]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Computer"),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [6]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Smart Phone"),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [7]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" Design"),
              _createElementVNode("span", null, "(12)", -1)
            ])),
            _: 1,
            __: [8]
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "sidebar-widget-title" }, "Filter By Price", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            id: "min",
            type: "range",
            min: _ctx.minRange,
            max: _ctx.maxRange,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minValue) = $event))
          }, null, 8, _hoisted_7), [
            [_vModelText, _ctx.minValue]
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "max",
            type: "range",
            min: _ctx.minRange,
            max: _ctx.maxRange,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maxValue) = $event))
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.maxValue]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, " $" + _toDisplayString(_ctx.minValue), 1),
          _createElementVNode("span", _hoisted_11, " $" + _toDisplayString(_ctx.maxValue), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "sidebar-widget-title" }, "Tags", -1)),
      _createElementVNode("ul", _hoisted_13, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Electronics")
            ])),
            _: 1,
            __: [11]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("Sale")
            ])),
            _: 1,
            __: [12]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("New")
            ])),
            _: 1,
            __: [13]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("Popular")
            ])),
            _: 1,
            __: [14]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("Earphone")
            ])),
            _: 1,
            __: [15]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("Keyboard")
            ])),
            _: 1,
            __: [16]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("Laptop")
            ])),
            _: 1,
            __: [17]
          })
        ])
      ])
    ])
  ]))
}